import { render, staticRenderFns } from "./a2.vue?vue&type=template&id=93269f94&scoped=true&"
import script from "./a2.vue?vue&type=script&lang=js&"
export * from "./a2.vue?vue&type=script&lang=js&"
import style0 from "./a2.vue?vue&type=style&index=0&id=93269f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93269f94",
  null
  
)

export default component.exports